var _ = require("underscore");
var module = angular.module('octopusApp.projects');

module.directive('actionTemplateEditor', function() {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'areas/projects/views/action_template_editor.html',
    scope: {
      actionTemplate: '=',
      action: '=',
      process: '=',
      project: '='
    },
    controller: function($scope, sensitiveValue, octopusRepository, $q, $state, $stateParams){

        function isPropertySensitive(property){
            return Object.prototype.toString.call(property) === "[object Object]";
        };

        var version = $scope.action.Properties['Octopus.Action.Template.Version'];

        // AngularJS doesn't like direct binding to a constant value
        $scope.falseValue = false;

        $scope.isUpToDate = $scope.actionTemplate.Version == version;
        $scope.version = version;
        $scope.currentPropertyValues = {};

        _.each($scope.action.Properties, function(propertyValue, propertyName){
            if (isPropertySensitive(propertyValue)) {
                $scope.currentPropertyValues[propertyName] = "******";
            }
            else {
                $scope.currentPropertyValues[propertyName] = propertyValue;
            }
        });


        var versionGetter = $scope.isUpToDate ? $q.resolve($scope.actionTemplate) : octopusRepository.ActionTemplates.getVersion($scope.actionTemplate, version);

        versionGetter.then(function(actionTemplateVersion){
            $scope.actionTemplateVersion = actionTemplateVersion;
        }, function(error){
            if (error.StatusCode !== 404) throw error;
        });

        $scope.createResetValues = function() {
            $scope.resetValues = {};
            if ($scope.action == null) {
                return;
            }
            _.each($scope.actionTemplate.Parameters, function(parameter){

              if (parameter.DisplaySettings['Octopus.ControlType'] === 'Sensitive') {
                $scope.resetValues[parameter.Name] = sensitiveValue.getResetValue($scope.action.Properties[parameter.Name]);
                return;
              }

              if (parameter.Name in $scope.action.Properties) {
                $scope.resetValues[parameter.Name] = $scope.action.Properties[parameter.Name];
                return;
              }
            });
        };

        if ($scope.process) {
            $scope.allSteps = _.flatten($scope.process.Steps.map(function(a) { return a.Actions.map(function(action) { return action.Name; }); }));
        }

        $scope.reloadAndPreserveUrl = function(){
            return $state.transitionTo($state.current, $stateParams, { reload: true, inherit: false, notify: true, location: false});
        };

        $scope.resolveConflicts = function() {
            //Empty values are not usually sent to the server but in this case we really need to know that the user decided to set something to an empty value.
            $scope.actionTemplate.Parameters.forEach(function(p){
                if ($scope.overrides[p.Name] === undefined) {
                    $scope.overrides[p.Name] = null;
                }
            });

            var actionIdsByProcessId = {};
            actionIdsByProcessId[$scope.process.Id] = [$scope.action.Id];
            octopusRepository.ActionTemplates.updateActions($scope.actionTemplate, actionIdsByProcessId, null,  $scope.overrides).then(function(){
                $scope.reloadAndPreserveUrl();
            }, function(error){
                if (error.StatusCode !== 400) throw error;
                $scope.manualMergeRequired = true;
            });
        };

        $scope.mergeLatest = function() {
            var actionIdsByProcessId = {};
            actionIdsByProcessId[$scope.process.Id] = [$scope.action.Id];
            octopusRepository.ActionTemplates.updateActions($scope.actionTemplate, actionIdsByProcessId).then(function(){
                $scope.reloadAndPreserveUrl();
            }, function(error){
                if (error.StatusCode !== 400) throw error;

                $scope.overrides = {};
                $scope.actionTemplate.Parameters.forEach(function(p){
                    var propertyValue = $scope.action.Properties[p.Name];
                    if (propertyValue !== undefined) {
                        $scope.overrides[p.Name] = propertyValue;
                    }
                });

                $scope.manualMergeRequired = true;
            });
        };

        $scope.createResetValues();
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/action_template_editor.js
// module id = 5660663097894237
// module chunks = 1